export var nominalToThousand = function nominalToThousand(inputValue) {
  var resultCommaVal = inputValue.toString().replace(/[A-Za-z]/g, '').replace(',', 'M').replace(/[^\dM-]/g, '').replace(/^-/, 'N').replace(/-/g, '').replace('N', '').replace('M', '').replace(/^[/\d]{10}?$/g, '').replace(/(\d)(?=(\d{3})+$)/g, '$1' + '.');

  if (resultCommaVal.charAt(0) == '0') {
    return '';
  }

  return resultCommaVal;
};